<ng-container *ngIf="statistic$ | async as statistics">
  <div class="storage-info" *ngIf="statistics.totalSize <= statistics.totalStorageAllowed else limitReached">
    <svg-icon src="assets/icons/storage.svg"
              [svgStyle]="{ 'width.px': 16, 'height.px': 16, 'fill': '#979797' }">
    </svg-icon>
    <span>{{ statistics.totalSize | byteSize }} {{ 'STORAGE.used' | translate }} {{ statistics.totalStorageAllowed | byteSize }}</span>
  </div>

  <ng-template #limitReached>
    <div class="storage-info storage-info-error" >
      <svg-icon src="assets/icons/storage-warning.svg"
                [svgStyle]="{ 'width.px': 16, 'height.px': 16, 'fill': '#EA4D4D' }">
      </svg-icon>
      <span>{{ statistics.totalSize | byteSize }}/{{ statistics.totalStorageAllowed | byteSize }}
        ({{  'STORAGE.limit_reached' | translate }})
      </span>
    </div>
  </ng-template>
</ng-container>
